import React from 'react';
import Page from '../../components/ui/Page';
import EmptyState from '../../components/ui/EmptyState';

// Phase 4 builds this out (printable A4 comparison sheet + window.print()).
export default function CompareReportPage() {
  return (
    <Page maxW="4xl">
      <EmptyState emoji="🖨️" title="Compare report" subtitle="Coming in the next build step." />
    </Page>
  );
}
